import * as echarts from 'echarts'
// 图表基本混合
const echartBaseMixin = {
  props: {
    type: {
      type: String,
      default: 'line',
    },
    height: {
      type: [String, Number],
      default: '100%',
    },
    chartStyle: {
      type: Object,
      default: () => ({}),
    },
    // 图例
    fields: {
      type: Array,
      default: () => [],
    },
    // 数据源
    dataSource: {
      type: Array,
      default: () => [],
    },
    // 图表配置项
    defaultTitle: {
      type: Object,
      default: () => ({
        text: '',
      }),
    },
    title: {
      type: String,
      default: '',
    },
    titleStyle: {
      type: Object,
      default: () => ({}),
    },
    tooltip: {
      // trigger: 'axis',
      type: Object,
      default: () => ({
        trigger: 'axis',
      }),
    },
    grid: {
      // containLabel: true,
      type: Object,
      default: () => ({
        top: '10%',
        bottom: '25%',
        left: '5%',
        right: '5%',
      }),
    },
    toolbox: {
      type: Object,
      default: () => {},
    },
    legend: {
      type: [Object, Boolean],
      default: () => ({
        orient: 'horizontal', // 横向排列
        left: 'center', // 水平居中
        top: 'bottom', // 设置图例在底部
        itemWidth: 12, // 图标宽度
        itemHeight: 12, // 图标高度
        symbol: 'rect', // 图标类型
      }),
    },
    color: {
      type: Array,
      default: () => [],
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    // 是否加载
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isRender: true,
      saveLegendSelectd: [],
      legendSelectedStatus: null, // 当前图例的选中状态
      chartInstance: null, // 图表实例
    }
  },
  mounted() {
    this.initChart()
    this.initLegendSelectedStatus()
    setTimeout(() => {
      this.resizeChart()
    }, 10)
  },
  // 解决页面切换后并且改变页面窗口大小， 导致的图表压缩问题
  activated() {
    this.resizeChart()
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
    window.removeEventListener('resize', this.resizeChart)
  },
  methods: {
    // 初始化图表
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chart)
      this.renderChart()
      window.addEventListener('resize', this.resizeChart)
      this.initClickEvent?.()
    },
    initLegendSelectedStatus() {
      this.chartInstance.on('legendselectchanged', (params) => {
        // params.selected 是一个对象，包含所有图例的选中状态
        const selectedStatus = params.selected
        this.legendSelectedStatus = selectedStatus
      })
    },
    setLegend() {
      // 有做过图例变化的，原先动态维护的选中状态更新到图例配置中
      if (this.legendSelectedStatus) {
        this.legend.selected = this.legendSelectedStatus
      }

      // 设置图例
      this.$set(
        this.options,
        'legend',
        this.legend && {
          ...this.legend,
          data: this.fields.length ? this.fields : this.legend.data,
        }
      )
      // console.log('this.options', this.options)
    },
    findCurrPointData(x, y) {
      let currPointData = this.dataSource?.find((item) => item.type === x && item[y] !== undefined)
      const pointObj = { seriesName: y }
      if (currPointData && Object.keys(currPointData).length) {
        for (const key in currPointData) {
          if (key === 'type' || key.includes(y)) {
            pointObj[key] = currPointData[key]
          }
        }
      }
      return pointObj
    },
    // 清除画布
    clearChart() {
      if (this.chartInstance) {
        this.chartInstance.clear()
      }
    },
    // 图表缩放
    resizeChart() {
      // console.log('缩放图表信息：', this.chartInstance)
      if (this.chartInstance) {
        this.chartInstance.resize()
        if (this.type === 'line') {
          this.addImageMarkers()
        }
      }
    },
    // 渲染图表
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.setOption(this.options, true) // `true` 表示强制重绘
      }
    },
    showLoading() {
      console.log('进入加载哈数')
      this.chartInstance?.showLoading?.({
        text: '图表生成中...',
        color: '#1890FF',
        textColor: '#1281e8',
        lineWidth: 3,
        maskColor: 'rgba(255, 255, 255, 0.5)',
        zlevel: 0,
      })
    },
    hideLoading() {
      this.chartInstance?.hideLoading?.()
    },
  },
}

export { echartBaseMixin }
